import { useEffect, useState, useCallback } from 'react';
import { PluggyConnect } from 'react-pluggy-connect';
import {
  Spin,
  Layout,
  // Breadcrumb removido
} from 'antd';
import { useLocation } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';

import TabelaExtratos from '../../components/TabelaExtratos';
import * as S from './styles';
import ComboBox from '../../components/ComboBox/ComboBox';
// useParams removido
import api from '../../service/api';
import { User } from '../acess';
// Header desestruturado de Layout
const { Content, Header } = Layout;

interface LocationState {
  id: string;
}

const Admin: React.FC = () => {
  const [isSpinning] = useState<boolean>(false)
  const antIcon = <LoadingOutlined style={{ fontSize: 34, color: "#2ce414" }} spin />
  const location = useLocation<LocationState>();
  const id = location.state?.id;
  const [currentUser, setCurrentUser] = useState<User | undefined>();
  const [apiKey, setApiKey] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);

  const GetApiKey = useCallback(async () => {
    try {
      // AJUSTE: Passamos um objeto vazio {} para garantir que o Content-Type seja JSON
      // e evitar o erro 415 em alguns servidores que rejeitam corpo nulo.
      const response = await api.post('api/Pluggy/creatConnectToken', {});
      setApiKey(response.data);
    } catch (error: any) {
      // Verifica se o erro possui uma resposta e se o status é 415
      if (error.response && error.response.status === 415) {
        // AQUI O ERRO 415 É IGNORADO/APENAS LOGADO
        console.warn("Aviso: Erro 415 (Unsupported Media Type) capturado e ignorado na obtenção do token.");
        // O código continua para a próxima linha (finally implícito)
        // Se o token for essencial, você pode querer manter o setIsLoading(true) ou tentar novamente.
        return;
      }

      // Trata outros erros
      console.error("Erro ao obter token:", error);
    } finally {
      // Movemos o setIsLoading(false) para o GetCliente, mas se o token falhou,
      // precisamos garantir que a tela não fique presa.
      if (!apiKey) {
        setIsLoading(false);
      }
    }
  }, [apiKey]); // Dependência em apiKey para garantir que o finally não zere o loading

  const GetCliente = useCallback(async (userId: string | undefined) => {
    if (!userId) {
      setIsLoading(false);
      return;
    }

    try {
      const response = await api.get(`api/Cliente/${userId}`);
      setCurrentUser(response.data);
      localStorage.setItem('cliente', JSON.stringify(response.data));
    } catch (error) {
      console.error("Erro ao obter cliente:", error);
      // Manter a interface limpa em caso de erro.
      setCurrentUser(undefined);
    } finally {
      // Zere o loading após a tentativa de carregar o cliente
      setIsLoading(false);
    }
  }, []);

  // Efeito 1: Obter a API Key
  useEffect(() => {
    GetApiKey();
  }, [GetApiKey]);

  // Efeito 2: Carregar o cliente
  useEffect(() => {
    // Se o ID ainda não foi carregado, o GetCliente fará a verificação de guarda.
    GetCliente(id);
  }, [id, GetCliente]);

  const onSuccess = () => {
  };

  const onError = (error: Error) => {
    console.error("An error occurred:", error.message);
  };

  // Renderiza Spin de tela cheia enquanto carrega
  if (isLoading) {
    return (
      <Layout style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Spin indicator={antIcon} spinning={true} size="large" />
      </Layout>
    );
  }

  return (
    <Spin indicator={antIcon} spinning={isSpinning}>
      <Header
        style={{
          backgroundColor: "#f0f2f5",
          display: 'flex',
          padding: "0 150px",
          height: "auto",
          maxHeight: "60px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* PluggyConnect só é renderizado se tiver apiKey e não estiver carregando */}
        {apiKey && (
          <PluggyConnect
            connectToken={apiKey}
            onSuccess={onSuccess}
          // onError={onError}
          />
        )}
        <S.ContainerImage>
          <img src={"data:image/png;base64," + currentUser?.img} alt="logo" />
        </S.ContainerImage>
        <S.ContainerWord>
          Contas e Extratos
        </S.ContainerWord>

        <S.MenuContainer>
          <ComboBox
            options={[
              { label: 'CONCILIADOR VENDAS', url: '/ConciliacaoVendas', isExternal: true },
              { label: 'PORTAL ADMINISTRADORAS', url: `https://login.assessoriacartoes.com.br/redirect/${id}`, isExternal: true },
            ]}
          />
        </S.MenuContainer>
      </Header>

      <Layout className="layout">
        <Content style={{ backgroundColor: "white", padding: '0 50px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', }}>
          {currentUser && <TabelaExtratos currentUser={currentUser} />}
        </Content>
      </Layout>
    </Spin>
  )
}

export default Admin;